import React from 'react';
import cn from 'classnames';
import { ILink } from 'tbk-components/src/components/Button';

export interface IButtonGeolocateResult {
	location: google.maps.LatLng;
	results?: any;
	status?: any;
}

export interface IButtonGeolocateProps extends ILink {
	geolocateAddress?: boolean;
	// Automatically centers the map to the user's location
	autoCenter?: boolean;
	// eslint-disable-next-line no-unused-vars
	onGeolocate?: (result: IButtonGeolocateResult) => void;
	// eslint-disable-next-line no-unused-vars
	onError?: (error: any) => void;
	map?: google.maps.Map;
	className?: string;
	classNames?: string[];
}

/**
 * Alternating Text and Images
 * @block
 * @icon button
 */
const ButtonGeolocate: React.FC<IButtonGeolocateProps> = ({
	geolocateAddress = false,
	autoCenter = true,
	onGeolocate,
	onError,
	map,
	className,
	classNames = [],
	label,
	children,
	...props
}) => {
	const [isLoading, setIsLoading] = React.useState(false);

	return (
		<button
			{...props}
			disabled={isLoading}
			className={cn(
				className || [
					'btn-geolocate',
					isLoading && 'btn-geolocate--loading',
					...classNames,
				],
			)}
			type="button"
			onClick={(e) => {
				e.preventDefault();

				if (!navigator.geolocation) {
					return;
				}

				setIsLoading(true);

				navigator.geolocation.getCurrentPosition(
					(result) => {
						const lat = result.coords.latitude;
						const lng = result.coords.longitude;

						const location = new google.maps.LatLng(lat, lng);

						if (map && autoCenter === true) {
							map.panTo(location);
						}

						if (!onGeolocate) {
							return;
						}

						if (geolocateAddress === true) {
							const geocoder = new google.maps.Geocoder();
							geocoder.geocode(
								{
									location,
								},
								(results, status) => {
									onGeolocate({ location, results, status });
								},
							);
						} else {
							onGeolocate({ location });
						}

						setIsLoading(false);
					},
					(error) => {
						onError(error);
						setIsLoading(false);
					},
				);
			}}
		>
			{label}
			{children}
		</button>
	);
};

export default ButtonGeolocate;
